export const GET_PORTFOLIOGRAPH_REQUESTED = 'GET_PORTFOLIOGRAPH_REQUESTED';
export const GET_PORTFOLIOGRAPH_SUCCESSFUL = 'GET_PORTFOLIOGRAPH_SUCCESSFUL';
export const GET_PORTFOLIOGRAPH_ABORTED = 'GET_PORTFOLIOGRAPH_ABORTED';
export const GET_PORTFOLIOGRAPH_FAILED = 'GET_PORTFOLIOGRAPH_FAILED';
